import React, { useState } from 'react';
import { Mail, CheckCircle2, Loader2 } from 'lucide-react';
import { devError } from '../../utils/devLog';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FooterSubscribe = () => {
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState(''); // honeypot
  const [status, setStatus] = useState('idle'); // idle | loading | done | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    try {
      const res = await fetch(`${API}/crm/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), website }),
      });
      if (res.ok) {
        setStatus('done');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (err) {
      devError(err);
      setStatus('error');
    }
  };

  return (
    <div data-testid="footer-subscribe">
      <h3 className="text-lg font-bold text-gray-600 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Subscribe to updates
      </h3>
      <p className="text-sm text-gray-500 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
        Product news and print-industry insights, straight to your inbox. No spam — unsubscribe anytime.
      </p>

      {status === 'done' ? (
        <div className="flex items-center gap-2 text-sm text-green-600" data-testid="footer-subscribe-success" style={{ fontFamily: 'Inter, sans-serif' }}>
          <CheckCircle2 size={18} /> You&apos;re on the list — thank you!
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="relative">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              data-testid="footer-subscribe-input"
              className="w-full pl-10 pr-3 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 focus:border-[#00BCE4] focus:ring-2 focus:ring-[#00BCE4]/20 outline-none"
              style={{ fontFamily: 'Inter, sans-serif' }}
            />
          </div>
          {/* Honeypot — hidden from humans */}
          <input
            type="text"
            tabIndex={-1}
            autoComplete="off"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            className="hidden"
            aria-hidden="true"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            data-testid="footer-subscribe-submit"
            className="inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-lg text-sm font-semibold bg-[#00BCE4] text-white hover:bg-[#00a5cc] disabled:opacity-60 transition-colors"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {status === 'loading' && <Loader2 size={15} className="animate-spin" />}
            Subscribe
          </button>
          {status === 'error' && (
            <p className="text-xs text-red-500" data-testid="footer-subscribe-error">
              Something went wrong. Please try again.
            </p>
          )}
        </form>
      )}
    </div>
  );
};

export default FooterSubscribe;
